(function () {
  var STORAGE_KEY = 'ibj_compare_v1';
  var MAX_ITEMS = 4;
  var barEl, modalEl;

  function getItems() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch (e) {}
    render();
  }

  function toggle(payload) {
    var items = getItems();
    var idx = items.findIndex(function (i) {
      return i.handle === payload.handle;
    });
    if (idx > -1) {
      items.splice(idx, 1);
    } else {
      if (items.length >= MAX_ITEMS) {
        window.alert('Maksimal ' + MAX_ITEMS + ' produk untuk dibandingkan.');
        return;
      }
      items.push(payload);
    }
    setItems(items);
    syncButtons();
  }

  function syncButtons() {
    var selectedHandles = getItems().map(function (i) {
      return i.handle;
    });
    document.querySelectorAll('[data-compare-toggle]').forEach(function (btn) {
      var handle = btn.getAttribute('data-compare-handle');
      btn.classList.toggle('is-active', selectedHandles.indexOf(handle) > -1);
    });
  }

  function render() {
    var items = getItems();
    if (!barEl) return;
    if (items.length === 0) {
      barEl.hidden = true;
      closeModal();
      return;
    }
    barEl.hidden = false;
    var thumbsWrap = barEl.querySelector('.compare-bar-thumbs');
    thumbsWrap.innerHTML = items
      .map(function (i) {
        var img = i.image
          ? '<img src="' + i.image + '" alt="" loading="lazy">'
          : '<div class="compare-bar-thumb-empty"></div>';
        return (
          '<div class="compare-bar-thumb">' +
          img +
          '<button type="button" class="compare-bar-thumb-remove" data-compare-remove="' +
          i.handle +
          '" aria-label="Hapus">&times;</button></div>'
        );
      })
      .join('');
    barEl.querySelector('.compare-bar-count').textContent = items.length + ' produk dipilih';
    var openBtn = barEl.querySelector('.compare-bar-open');
    openBtn.disabled = items.length < 2;
  }

  function openModal() {
    var items = getItems();
    if (!modalEl || items.length < 2) return;
    var rows = [
      [
        'Gambar',
        function (i) {
          if (!i.image) {
            return '<div class="compare-modal-img compare-modal-img--empty"></div>';
          }
          return '<img src="' + i.image + '" alt="" loading="lazy" class="compare-modal-img">';
        },
      ],
      [
        'Nama',
        function (i) {
          return '<a href="' + i.url + '">' + i.title + '</a>';
        },
      ],
      [
        'Brand',
        function (i) {
          return i.vendor || '-';
        },
      ],
      [
        'Kategori',
        function (i) {
          return i.type || '-';
        },
      ],
      [
        'Harga',
        function (i) {
          return i.price;
        },
      ],
      [
        'Varian',
        function (i) {
          return i.variant || '-';
        },
      ],
      [
        'Berat',
        function (i) {
          return i.weight || '-';
        },
      ],
      [
        'Ringkasan',
        function (i) {
          return '<span class="compare-summary">' + (i.summary || '-') + '</span>';
        },
      ],
    ];
    var html = '<table class="compare-table"><tbody>';
    rows.forEach(function (row) {
      html += '<tr><th>' + row[0] + '</th>';
      items.forEach(function (i) {
        html += '<td>' + row[1](i) + '</td>';
      });
      html += '</tr>';
    });
    html += '</tbody></table>';
    modalEl.querySelector('.compare-modal-body').innerHTML = html;
    modalEl.hidden = false;
    document.body.classList.add('compare-modal-open');
  }

  function closeModal() {
    if (!modalEl) return;
    modalEl.hidden = true;
    document.body.classList.remove('compare-modal-open');
  }

  document.addEventListener('click', function (e) {
    var toggleBtn = e.target.closest('[data-compare-toggle]');
    if (toggleBtn) {
      e.preventDefault();
      var payload;
      try {
        payload = JSON.parse(toggleBtn.getAttribute('data-compare-payload'));
      } catch (err) {
        return;
      }
      toggle(payload);
      return;
    }

    var removeBtn = e.target.closest('[data-compare-remove]');
    if (removeBtn) {
      e.preventDefault();
      var handle = removeBtn.getAttribute('data-compare-remove');
      setItems(
        getItems().filter(function (i) {
          return i.handle !== handle;
        })
      );
      syncButtons();
      return;
    }

    if (e.target.closest('.compare-bar-open')) {
      e.preventDefault();
      openModal();
      return;
    }

    if (e.target.closest('.compare-bar-clear')) {
      e.preventDefault();
      setItems([]);
      syncButtons();
      return;
    }

    if (e.target.closest('.compare-modal-close') || e.target.closest('.compare-modal-backdrop')) {
      e.preventDefault();
      closeModal();
      return;
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    barEl = document.querySelector('[data-compare-bar]');
    modalEl = document.querySelector('[data-compare-modal]');
    render();
    syncButtons();
  });
})();
